import React from "react";
import { FiMapPin, FiBookOpen } from "react-icons/fi";
import { FaBuilding } from "react-icons/fa";
const UserProfile = ({ profile, repos = [], darkMode }) => {
  return (
    <div className="max-w-[900px] mx-auto mt-10 bg-[#394955] rounded-3xl shadow-2xl p-10 flex flex-row gap-10 transition-all duration-300">
      {/* Left: Avatar at Top Left */}
      <div className="flex flex-col items-center w-44">
        <div className="overflow-hidden rounded-full border-4 border-[#2B3842] shadow-lg w-40 h-40 hover:scale-105 transform transition duration-300 ease-in-out">
          <img
            src={profile.avatar_url}
            alt={profile.name}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      {/* Right: User Info */}
      <div className="flex flex-col justify-start flex-1 text-left">
        <h2 className="text-white font-bold text-3xl mb-2 tracking-wide">
          {profile.name}
        </h2>
        <p className="text-gray-200 text-lg font-medium leading-relaxed mb-5">
           {profile.bio}
        </p>
        {/* Followers / Following / Repos */}
        <div className="flex gap-4 mb-5">
          <span className="bg-[#2C343E] px-6 py-2 rounded-lg text-base font-semibold flex items-center gap-1 min-w-[120px] justify-center">
            <span className="text-white">{profile.followers}</span>
            <span className="text-orange-400">Followers</span>
          </span>
          <span className="bg-[#2C343E] px-6 py-2 rounded-lg text-base font-semibold flex items-center gap-1 min-w-[120px] justify-center">
            <span className="text-white">{profile.following}</span>
            <span className="text-orange-400">Following</span>
          </span>
          <span className="bg-[#2C343E] px-6 py-2 rounded-lg text-base font-semibold flex items-center gap-1 min-w-[120px] justify-center">
            <span className="text-white">{profile.public_repos}</span>
            <span className="text-orange-400">Repos</span>
          </span>
        </div>
        {/* Location and Institution */}
        <div className="flex flex-wrap gap-6 items-center mb-6 text-gray-200 text-lg font-medium">
          {profile.location && (
            <span className="flex items-center gap-2">
              <FiMapPin className="text-green-400" />
              {profile.location}
            </span>
          )}
          {profile.company && (
            <span className="flex items-center gap-2">
              <FaBuilding className="text-green-400" />
              {profile.company}
            </span>
          )}
        </div>
        {/* Activity Button */}
        {profile.html_url && (
          <a
            href={profile.html_url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-orange-400 to-pink-500 px-8 py-3 rounded-full text-base font-semibold text-white shadow-md hover:scale-105 transition-transform duration-300 w-fit"
          >
            Activity Timeline
          </a>
        )}
        {/* Repository Badges */}
        <div className="flex flex-wrap gap-4 mt-8">
          {repos.map((repo) => (
            <a
              key={repo.id}
              href={repo.html_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center bg-[#2C343E] px-5 py-2.5 rounded-lg text-white font-semibold space-x-2 hover:bg-[#465469] transition"
            >
              <span>{repo.name}</span>
              {repo.language && (
                <span className="text-gray-400 bg-gray-700 px-2 py-0.5 ml-2 rounded text-sm">
                  {repo.language}
                </span>
              )}
              {repo.stargazers_count > 0 && (
                <span className="ml-2 flex items-center gap-1 text-yellow-300 font-bold">
                  <svg width="16" height="16" fill="currentColor" className="inline" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.396.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.32-.158-.888.283-.95l4.898-.696 2.06-4.408c.197-.42.73-.42.927 0l2.06 4.408 4.898.696c.441.062.612.63.283.95l-3.523 3.356.83 4.73c.078.443-.35.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                  {repo.stargazers_count}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
